var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.399 10.8991C31.0336 10.2644 31.0336 9.23556 30.399 8.60095C29.7645 7.96635 28.7355 7.96635 28.101 8.60095L5.35095 31.351C4.71635 31.9855 4.71635 33.0145 5.35095 33.649C5.98556 34.2836 7.01444 34.2836 7.64905 33.649L13.6655 27.6326C14.549 28.5924 15.6524 29.327 16.8834 29.7715C17.2718 29.9117 17.6849 30.015 18.5112 30.2216L19.5075 30.4707C20.0601 30.6088 20.3364 30.6779 20.554 30.6103C20.7428 30.5515 20.9037 30.4258 21.0065 30.2568C21.125 30.0622 21.125 29.7775 21.125 29.2078V20.1731L30.399 10.8991Z",
    fill: "#F6FBFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1249 9.79249V12.3271L9.36406 24.088L6.81717 23.7242C6.10243 23.622 5.47177 23.2032 5.10029 22.5841C3.96136 20.6859 3.96136 18.3145 5.10029 16.4162C5.47177 15.7972 6.10243 15.3784 6.81717 15.2763L10.605 14.7352C11.0949 14.6652 11.5318 14.3899 11.8063 13.9781L12.4029 13.0833C12.8753 12.3746 13.1116 12.0203 13.3743 11.7017C14.3011 10.5777 15.5131 9.72354 16.8834 9.22874C17.2717 9.08851 17.6848 8.98521 18.5111 8.77864L19.5074 8.52957C20.0601 8.39141 20.3363 8.32234 20.5539 8.39003C20.7427 8.44883 20.9036 8.57447 21.0065 8.74342C21.1249 8.93803 21.1249 9.22285 21.1249 9.79249Z",
    fill: "#F6FBFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/Mute.318a6fa4389d85aff7c1e7c3df704f6b.svg";
export { ForwardRef as ReactComponent };